import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DriveFileMoveRtlIcon(props: IconProps) {
    return <Icon {...props} iconKey={"drive_file_move_rtl"}/>
}
